import { render, staticRenderFns } from "./ItemDevice.vue?vue&type=template&id=f9ce3810&scoped=true"
import script from "./ItemDevice.vue?vue&type=script&lang=ts"
export * from "./ItemDevice.vue?vue&type=script&lang=ts"
import style0 from "./ItemDevice.vue?vue&type=style&index=0&id=f9ce3810&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ce3810",
  null
  
)

export default component.exports